import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import plTable from 'pl-table'
import 'pl-table/themes/index.css'
import VueCookies from 'vue-cookies'
import App from './App.vue'
import router from './router'

Vue.use(ElementUI);
Vue.use(plTable)
Vue.use(VueCookies)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
